var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header border-bottom d-flex align-items-center justify-content-center p-3"},[_c('img',{attrs:{"src":_vm.logo,"alt":"LaboPractice"}}),_c('div',{staticClass:"locale-switcher-container"},[_c('LocaleSwitcher')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }